import type { PowerTransformerResult } from '../../../..';
import type {
  PowerTransformerEvaluatedAvailableCapacities,
  PowerTransformerEvaluatedLoadingPercents
} from '../../../../derived-state/loadFlowSummary';
import { NumbersRange } from '../../../../domain/NumbersRange';
import { Percent } from '../../../../domain/Percent';
import { Messenger } from '../../../AttentionStatusRepository';
import type { ForPowerTransformerEvaluation } from './forPowerTransformerEvaluation';

export class PowerTransformerSummaryEvaluation {
  private PowerTransformerResults: PowerTransformerResult[];
  private evaluationEngine: ForPowerTransformerEvaluation;

  constructor(
    PowerTransformerResults: PowerTransformerResult[],
    evaluationEngine: ForPowerTransformerEvaluation
  ) {
    this.PowerTransformerResults = PowerTransformerResults;
    this.evaluationEngine = evaluationEngine;
  }

  evaluateLoadingPercents(): PowerTransformerEvaluatedLoadingPercents {
    const loadingPercents = this.PowerTransformerResults.map(
      e => e.loadingPercent
    );

    const voltageRange = new NumbersRange(loadingPercents);
    const min = this.evaluationEngine.evaluateLoadingPercent(
      Percent.fromFloat(voltageRange.min),
      Messenger.notDelegated()
    );
    const max = this.evaluationEngine.evaluateLoadingPercent(
      Percent.fromFloat(voltageRange.max),
      Messenger.notDelegated()
    );

    return { min, max };
  }

  evaluateAvailableCapacities(): PowerTransformerEvaluatedAvailableCapacities {
    const availableCapacities = this.PowerTransformerResults.map(
      e => e.availableCapacity
    );

    const voltageRange = new NumbersRange(availableCapacities);
    const min = this.evaluationEngine.evaluateAvailableCapacity(
      voltageRange.min,
      Messenger.notDelegated()
    );
    const max = this.evaluationEngine.evaluateAvailableCapacity(
      voltageRange.max,
      Messenger.notDelegated()
    );

    return { min, max };
  }
}
